import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, combineLatest, filter, map } from 'rxjs';
import { UserService } from '../../../global-services/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {

  constructor(
    private readonly _userService: UserService,
    private readonly _router: Router

  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    return combineLatest([this._userService.isAdminObs, this._userService.userSubject]).pipe(
      filter(([isAdmin, user]) => isAdmin || !!user),
      map(([isAdmin, user]) => isAdmin || user.id === route.params.id),
      map(isUser => isUser ? true : this._router.parseUrl(''))
    )

  }

}
